import { Planet20Regular, Info20Regular, Beaker16Regular, ClipboardBulletListLtr20Regular } from '@fluentui/react-icons';
import { createModuleConfig } from '../createModuleConfig';
import { lazyPage } from '../lazyPage';

const TestDriveOverviewPage = lazyPage(() => import('./tools/overview/pages/OverviewPage'));
const TestDesignerPage = lazyPage(() => import('./tools/regression/pages/TestDesignerPage'));
const TestDeckPage = lazyPage(() => import('./tools/test-deck/pages/TestDeckPage'));

const testDriveModuleConfig = createModuleConfig({
  key: 'test-drive',
  name: 'Test Drive',
  domain: { title: 'Test Drive', icon: Beaker16Regular },
  tools: [
    { 
      key: 'overview',
      name: 'Overview',
      title: 'Test Drive Overview',
      path: '/test-drive', 
      element: <TestDriveOverviewPage />, 
      nav: { name: 'Overview', icon: Planet20Regular }
    },
    { 
      key: 'test-designer',
      name: 'Test Designer',
      title: 'Test Designer',
      path: '/test-drive/test-designer', 
      element: <TestDesignerPage />, 
      nav: { name: 'Regression Tests', icon: Info20Regular }
    },
    {
      key: 'test-deck',
      name: 'Test Deck',
      title: 'Test Deck',
      path: '/test-drive/test-deck',
      element: <TestDeckPage />,
      nav: { name: 'Test Deck', icon: ClipboardBulletListLtr20Regular }
    },
  ],
});

export default testDriveModuleConfig;
